<template>
  <a class="product__image" :href="linkURL" :title="`${item.title} Magazine Subscription`" @click.prevent="handleClick(item)">
    <div v-if="showFreeGiftOverlay" class="freegift-overlay ">
      <span class="freegift-overlay__txt1">FREE</span>
      <span class="freegift-overlay__txt2">GIFT</span>
    </div>
    <span v-else-if="showOverlay" class="saving-overlay ">
      <span class="saving-overlay__txt1">SAVE</span>
      <span class="saving-overlay__txt2">{{ item.offer.save }}%</span>
    </span>
    <img v-bind="imageProps" loading="lazy" :src="imageURL" :data-src="placeholder" class="shadow5" />
  </a>
</template>

<script>
import { createPathOrURLWithQueryParam } from '~/lib/util/page'

export default {
  name: 'TheMagazineImage',
  // serverCacheKey: props => `TheMagazineImage::${props.item.sku}::SO_${props.showSaveOverlay}::FGO_${props.showFreeGiftOverlay}`,
  serverCacheKey() {
    return false
  },
  props: {
    item: {
      type: Object,
      required: true,
      default() {
        return {}
      }
    },
    showSaveOverlay: {
      type: Boolean,
      required: false,
      default() {
        return false
      }
    },
    showFreeGiftOverlay: {
      type: Boolean,
      required: false,
      default() {
        return false
      }
    },
    imageSrc: {
      type: String,
      required: false,
      default() {
        return ''
      }
    }
  },
  data() {
    return {
      placeholder: '~/assets/images/image_placeholder.png',
      imageProps: {
        title: `${this.item.title} Magazine Subscription`,
        alt: `${this.item.title} Magazine Subscription`,
        width: 186,
        height: 255
      },
      isPocketmagsPlus: this.item.title === 'Pocketmags Plus+',
      isGiftCard: this.item?.type === 'GIFTCARD' || false,
      isEGiftCard: this.item?.type === 'EGIFTCARD' || false,
      showOverlay: this.showSaveOverlay && this.item.offer.save > 0 && this.showSaveOverlay
    }
  },
  computed: {
    imageURL() {
      if (this.imageSrc && this.imageSrc !== '') {
        return this.imageSrc
      }
      const imagePath = this.getFullImagePath(this.item)
      return `${this.$config.imgixURL}${imagePath}?auto=format&fit=fill&fill=solid&bg=0FFF&w=210`
    },
    linkURL() {
      const url = this.item?.url
      if (!url) {
        return this.$config.baseURL
      }
      return url.replace(/magazine-(\d{4,5})$/g, 'magazine')
    }
  },
  methods: {
    getFullImagePath(item) {
      // console.info(`getFullImagePath item=`, item)
      let imagePath = item?.imageUrl?.split('?').shift()

      if (item.title === 'Pocketmags Plus+') {
        return `/pocketmagsplus/image.png`
      }

      // Custom image ONLY for a Pocketmags Plus product
      if (this.isPocketmagsPlus) {
        console.log('isPocketmagsPlus imagePath=', imagePath)
        return `${imagePath}`
      }

      if (!imagePath) {
        imagePath = item?.image_path?.split('?').shift()
      }

      // IMGIX CDN new Cover Update Logic
      if (imagePath?.startsWith('/products/')) {
        return imagePath
      }

      // JMAG deafult M1 Image
      if (imagePath?.startsWith('/catalog/product')) {
        return imagePath
      }

      return `/catalog/product${imagePath}`
    },
    handleClick(item) {
      // Trigger GTM event
      if (item?.title && (item?.url_path || item?.url)) {
        this.$store.commit('s/addtorecentlyviewed', this.item)
        // Redirct to the offer page
        const href = item?.url_path?.replace(/magazine-(\d{4,5})$/g, 'magazine') || item?.url?.replace(/magazine-(\d{4,5})$/g, 'magazine')
        window.location.href = createPathOrURLWithQueryParam({ pathOrURL: href, query: this.$route.query })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.product__image {
  img {
    border-radius: 7px;
    max-width: 100%;
    height: auto;
  }
}

.saving-overlay,
.freegift-overlay {
  bottom: -3px;
  height: 0;
  position: absolute;
  right: -3px;
  width: 60px;
  height: 60px;
  z-index: 0;
  background-color: #df0000;
  border-radius: 30px;
  border: 2px #fff solid;
}

.saving-overlay__txt1 {
  position: absolute;
  color: #fff;
  font-weight: 400;
  width: 60px;
  right: 0;
  top: 10px;
  font-size: 15px;
  text-align: center;
  right: -2px;
}

.saving-overlay__txt2 {
  position: absolute;
  color: #fff;
  font-weight: 700;
  width: 60px;
  right: 0;
  top: 25px;
  font-size: 18px;
  text-align: center;
  right: -2px;
}

.freegift-overlay__txt1 {
  position: absolute;
  color: #fff;
  font-weight: 700;
  width: 60px;
  right: -3px;
  top: 10px;
  font-size: 18px;
  text-align: center;
}

.freegift-overlay__txt2 {
  position: absolute;
  color: #fff;
  font-weight: 700;
  width: 60px;
  right: -3px;
  top: 25px;
  font-size: 18px;
  text-align: center;
}
</style>
